
var SHOP_CONFIG = new Map();
SHOP_CONFIG.set("product_img_swipe_speed", 500);
SHOP_CONFIG.set("mlpopup_enabled", true); // enable popup callback?
SHOP_CONFIG.set("mlpopup_delay", 30000); // ms delay for popup
SHOP_CONFIG.set("mlpopup_cookie", "mailinglistpopup"); // name of cookie
SHOP_CONFIG.set("mlpopup_classadd", "mailing-list"); // class of existing section element to duplicate
